// Takes a list of string params and returns an object containing mirrored key/value pairs
// Ie ['a', 'b', 'c'] becomes { a: 'a', b: 'b', c: 'c' }
export const keyMirror = (...items) =>
  items.reduce((acc, item) => {
    acc[item] = item
    return acc
  }, {})
